import type { ApiEffect } from '../index.h'
import type { CurrentSubscription } from '../interfaces/subscriptions'

import { createEffect } from 'effector'

// GET /v3/subscriptions/current
export const getCurrentSubscriptionFx: ApiEffect<void, CurrentSubscription> =
  createEffect()
